import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (selected) => ({
  p: 1,
  transition: (p) => p.transitions.create('background-color'),
  w: '100%',
  borderRadius: (p) => p.spacing(0.5),
  background: selected
    ? (p) => p.palette.grey[200]
    : (p) => p.palette.common.white,
  cursor: 'pointer',

  '&:hover': {
    background: (p) => p.palette.grey[200],
  },
});
